import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { SessionProvider, useSession } from "./context/SessionContext";
import { CartProvider } from "./context/CartContext";
import { FavoritesProvider } from "./context/FavoritesContext";

import ClientLogin from "./pages/ClientLogin";
import Catalog from "./pages/Catalog";
import CheckoutReview from "./pages/CheckoutReview";
import OrderSuccess from "./pages/OrderSuccess";
import MyOrders from "./pages/MyOrders";
import MyFavorites from "./pages/MyFavorites";
import MySuggestions from "./pages/MySuggestions";
import MyCartera from "./pages/MyCartera";
import ResetPassword from "./pages/ResetPassword";

import { AdminLayout } from "./components/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminOrderDetail from "./pages/admin/AdminOrderDetail";
import AdminCatalog from "./pages/admin/AdminCatalog";
import AdminLogs from "./pages/admin/AdminLogs";
import AdminCronMonitor from "./pages/admin/AdminCronMonitor";
import AdminVendedores from "./pages/admin/AdminVendedores";
import AdminVendedoresCatalogo from "./pages/admin/AdminVendedoresCatalogo";
import AdminPSM from "./pages/admin/AdminPSM";
import AdminMarcas from "./pages/admin/AdminMarcas";
import AdminClientPasswords from "./pages/admin/AdminClientPasswords";
import AdminCommercial from "./pages/admin/AdminCommercial";
import AdminTsol from "./pages/admin/AdminTsol";

const RequireClient = ({ children }) => {
  const { customer, loading } = useSession();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-cm-ink-soft">Cargando...</div>;
  if (!customer) return <Navigate to="/" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { customer, loading } = useSession();
  if (loading) return null;
  if (customer) return <Navigate to="/catalogo" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <CartProvider>
          <FavoritesProvider>
          <TooltipProvider delayDuration={250}>
          <Routes>
            {/* Client portal */}
            <Route path="/" element={<PublicOnly><ClientLogin /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/catalogo" element={<RequireClient><Catalog /></RequireClient>} />
            <Route path="/checkout" element={<RequireClient><CheckoutReview /></RequireClient>} />
            <Route path="/mis-pedidos" element={<RequireClient><MyOrders /></RequireClient>} />
            <Route path="/mis-favoritos" element={<RequireClient><MyFavorites /></RequireClient>} />
            <Route path="/sugeridos" element={<RequireClient><MySuggestions /></RequireClient>} />
            <Route path="/mi-cartera" element={<RequireClient><MyCartera /></RequireClient>} />
            <Route path="/pedido-exitoso/:number" element={<RequireClient><OrderSuccess /></RequireClient>} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="pedidos" element={<AdminOrders />} />
              <Route path="pedidos/:orderId" element={<AdminOrderDetail />} />
              <Route path="vendedores" element={<AdminVendedores />} />
              <Route path="vendedores-arcos" element={<AdminVendedoresCatalogo />} />
              <Route path="psm" element={<AdminPSM />} />
              <Route path="marcas" element={<AdminMarcas />} />
              <Route path="contrasenas" element={<AdminClientPasswords />} />
              <Route path="comercial" element={<AdminCommercial />} />
              <Route path="catalogo" element={<AdminCatalog />} />
              <Route path="logs" element={<AdminLogs />} />
              <Route path="cron" element={<AdminCronMonitor />} />
              <Route path="integracion-tsol" element={<AdminTsol />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          </TooltipProvider>
          </FavoritesProvider>
        </CartProvider>
      </SessionProvider>
    </BrowserRouter>
  );
}

export default App;
